import React from 'react';
import './blog.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog, source = '', width = '' }) => {
  const altText = blog.heroImageAltText || blog.name;
  const imageComponent = (
    <img
      src={blog.imageUrl}
      className="desktop-blog-card--image"
      alt={altText}
    />
  );
  return (
    <div className={`desktop-blog-card ${source} ${width}`}>
      {blog.isExternalBlog && (
        <a href={blog.actionUri} target="_blank">
          {imageComponent}
        </a>
      )}
      {!blog.isExternalBlog && (
        <Link to={`/${blog.actionUri}-bg`}>{imageComponent}</Link>
      )}
      {/*<img*/}
      {/*  src={blog.imageUrl}*/}
      {/*  className="desktop-blog-card--image"*/}
      {/*  alt={altText}*/}
      {/*/>*/}
      <div className="desktop-blog-card--title ellipsis">{blog.name}</div>
      <div className="desktop-blog-card--description ellipsis">
        {blog.description}
      </div>
      {blog.isExternalBlog && (
        <a
          href={blog.actionUri}
          target="_blank"
          className="button action-link more"
        >
          READ MORE
        </a>
      )}
      {!blog.isExternalBlog && (
        <Link to={`/${blog.actionUri}-bg`} className="button action-link more">
          READ MORE
        </Link>
      )}
    </div>
  );
};

BlogCard.propTypes = {
  blog: PropTypes.object.isRequired,
  source: PropTypes.oneOf(['category-pdp', 'segment-pdp']),
  width: PropTypes.oneOf(['full', 'half']),
};

export default BlogCard;
